import { brandLogos } from '@liveauctioneers/hammer-ui-core/brandAssets';
import { Loading } from '@liveauctioneers/hammer-ui-core/loading';

const AuthSSORedirectPage = () => {
    return (
        <div className="fixed top-0 right-0 bottom-0 left-0 z-[9999] flex h-screen w-screen items-center justify-center bg-background-primary">
            <div className="flex flex-col items-center justify-center gap-md">
                <img
                    alt="logo"
                    className="h-[30px] max-w-none"
                    height={30}
                    src={brandLogos.LiveAuctioneers.brand}
                    width={190}
                />
                <Loading size={32} />
            </div>
        </div>
    );
};

export default AuthSSORedirectPage;
